import { render, staticRenderFns } from "./EmailSyncList.vue?vue&type=template&id=44c2b11c&"
import script from "./EmailSyncList.vue?vue&type=script&lang=js&"
export * from "./EmailSyncList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports